import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'

const Seller = (props) => {
  return (
    <div className='seller'>
      <button className="close" onClick={props.closeSellerPreview}>
        <FaArrowLeft />
      </button>
      <div className="content">
        <div className="loader"></div>
      </div>
      <div className="bg" onClick={props.closeSellerPreview}></div>
    </div>
  )
}

export default Seller